import { Component, Inject, inject, ViewContainerRef } from '@angular/core';
import { RoleState } from 'src/app/core/models/role.model';
import { AuthService } from 'src/app/core/services/auth.service';
import { LocalStorageService } from 'src/app/core/services/local-storage.service';
import { SidenavService } from 'src/app/core/services/sidenav.service';
import { SignalStore } from 'src/app/shared/functions/store.functions';
import {MatSelectModule} from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import {CommonModule} from '@angular/common';
@Component({
  selector: 'app-role-select',
  standalone: true,
  imports: [
    FormsModule,
    MatSelectModule,
    CommonModule
  ],
  templateUrl: './role-select.component.html',
  styleUrl: './role-select.component.css'
})
export class RoleSelectComponent {
  rolesSelected = this.roleStore.selectKey("role")
  selected = parseInt(this.localStorageService.getItem('role')!);

  constructor(
    private authService: AuthService,
    public sidenavService: SidenavService,
    private localStorageService: LocalStorageService,
    private vcf: ViewContainerRef,
    private router: Router,
    @Inject('role-store') private readonly roleStore = inject(SignalStore<RoleState>)
  ) {

  }


  changeRole(){
    const dato = this.roleStore.selectKey("role")().filter((el:any)=>el.id==this.selected)
    this.localStorageService.setItem('role', dato[0].id)
    this.router.navigate(['dashboard']).finally(()=>{
      window.location.reload();
    })

  }
}
